export const UPGRADE_BRAND_ACTION_NAMES = {
  INTERACT_REFERENCE_ACTION: 'User clicked into Title or URL field',
  INTERACT_SOCIAL_ACTION: 'User clicked into Social Link input field',
  ADD_CATEGORY: 'User tried to add second product category',
  ADD_PROJECTS: 'User clicked into project search bar',
  EDIT_PROJECT: 'User clicked on "edit" icon for an existing project',
  REVEAL_WEBSITE: 'User clicked into Primary URL field',
};

export const PAGE_NAME = 'brand dashboard';
